import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, Copy, CheckCircle } from 'lucide-react';
const GiftPayment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    item,
    price,
    type
  } = location.state || {};
  const [copied, setCopied] = useState<string | null>(null);
  const accountDetails = {
    bankName: 'Access Bank',
    accountName: 'Egbon Ayevbosa Joy',
    accountNumber: '1382036597'
  };
  const copyToClipboard = (text: string, field: string) => {
    navigator.clipboard.writeText(text);
    setCopied(field);
    setTimeout(() => setCopied(null), 2000);
  };
  if (!item) {
    navigate('/');
    return null;
  }
  return <div className="min-h-screen bg-cream" data-id="element-156">
      <div className="section-container" data-id="element-157">
        <button onClick={() => navigate(-1)} className="flex items-center text-gray-700 hover:text-emerald mb-8 transition-colors" data-id="element-158">
          <ArrowLeft size={20} className="mr-2" data-id="element-159" />
          Back
        </button>

        <div className="max-w-2xl mx-auto" data-id="element-160">
          <h1 className="section-heading" data-id="element-161">Payment Details</h1>

          <div className="bg-white border border-sage border-opacity-60 p-8 rounded-md shadow-md mb-8" data-id="element-162">
            <h2 className="font-serif text-2xl text-gray-800 mb-2" data-id="element-163">
              Selected Gift
            </h2>
            <p className="text-gray-700 text-lg mb-1" data-id="element-164">{item}</p>
            <p className="text-emerald font-semibold text-2xl mb-4" data-id="element-165">{price}</p>
            <p className="text-gray-600 text-sm" data-id="element-166">Category: {type}</p>
          </div>

          <div className="bg-sage bg-opacity-40 border-2 border-emerald border-opacity-30 p-8 rounded-md" data-id="element-167">
            <h2 className="font-serif text-2xl text-gray-800 mb-6 text-center" data-id="element-168">
              Bank Transfer Details
            </h2>

            <div className="space-y-4" data-id="element-169">
              <div className="flex justify-between items-center p-4 bg-white rounded-md" data-id="element-170">
                <div data-id="element-171">
                  <p className="text-gray-600 text-sm" data-id="element-172">Bank Name</p>
                  <p className="text-gray-800 font-medium" data-id="element-173">
                    {accountDetails.bankName}
                  </p>
                </div>
                <button onClick={() => copyToClipboard(accountDetails.bankName, 'bank')} className="text-emerald hover:text-emerald-dark transition-colors" data-id="element-174">
                  {copied === 'bank' ? <CheckCircle size={20} data-id="element-175" /> : <Copy size={20} data-id="element-176" />}
                </button>
              </div>

              <div className="flex justify-between items-center p-4 bg-white rounded-md" data-id="element-177">
                <div data-id="element-178">
                  <p className="text-gray-600 text-sm" data-id="element-179">Account Name</p>
                  <p className="text-gray-800 font-medium" data-id="element-180">
                    {accountDetails.accountName}
                  </p>
                </div>
                <button onClick={() => copyToClipboard(accountDetails.accountName, 'name')} className="text-emerald hover:text-emerald-dark transition-colors" data-id="element-181">
                  {copied === 'name' ? <CheckCircle size={20} data-id="element-182" /> : <Copy size={20} data-id="element-183" />}
                </button>
              </div>

              <div className="flex justify-between items-center p-4 bg-white rounded-md" data-id="element-184">
                <div data-id="element-185">
                  <p className="text-gray-600 text-sm" data-id="element-186">Account Number</p>
                  <p className="text-gray-800 font-medium text-xl" data-id="element-187">
                    {accountDetails.accountNumber}
                  </p>
                </div>
                <button onClick={() => copyToClipboard(accountDetails.accountNumber, 'account')} className="text-emerald hover:text-emerald-dark transition-colors" data-id="element-188">
                  {copied === 'account' ? <CheckCircle size={20} data-id="element-189" /> : <Copy size={20} data-id="element-190" />}
                </button>
              </div>
            </div>

            <div className="mt-8 p-6 bg-white rounded-md border-l-4 border-emerald" data-id="element-191">
              <h3 className="font-serif text-lg text-gray-800 mb-3" data-id="element-192">
                Important Instructions
              </h3>
              <ul className="space-y-2 text-gray-700" data-id="element-193">
                <li className="flex items-start" data-id="element-194">
                  <span className="text-emerald mr-2" data-id="element-195">•</span>
                  <span data-id="element-196">
                    When making the transfer, please indicate{' '}
                    <strong data-id="element-197">"Gift for Couple"</strong> in the
                    narration/description field
                  </span>
                </li>
                <li className="flex items-start" data-id="element-198">
                  <span className="text-emerald mr-2" data-id="element-199">•</span>
                  <span data-id="element-200">
                    Include your name so we can properly acknowledge your
                    generous gift
                  </span>
                </li>
                <li className="flex items-start" data-id="element-201">
                  <span className="text-emerald mr-2" data-id="element-202">•</span>
                  <span data-id="element-203">
                    After sending, you may take a screenshot of the transaction
                    for your records
                  </span>
                </li>
              </ul>
            </div>

            <div className="mt-6 text-center" data-id="element-204">
              <p className="text-gray-700 italic font-script text-xl" data-id="element-205">
                Thank you for your generous gift! We are truly grateful for your
                love and support.
              </p>
            </div>
          </div>

          <div className="mt-8 text-center" data-id="element-206">
            <button onClick={() => navigate('/')} className="px-8 py-3 bg-emerald text-white font-sans text-sm uppercase tracking-wider hover:bg-emerald-dark transition-all duration-300" data-id="element-207">
              Return to Home
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default GiftPayment;